import classNames from 'classnames';
import React from 'react';
import './NewsBlock.scss';

interface NewsBlockProps {
  Key?: number;
  Image: string;
  ImageUrl: string;
  Topic: string;
  TopicUrl: string;
  Title: string;
  Description?: string;
  PublishDate: string;
  ImageIsRight?: boolean;
  imagePosition?: 'left' | 'right' | 'top';
}

export const NewsBlock = ({
  Key,
  Image,
  ImageUrl,
  Topic,
  TopicUrl,
  Title,
  Description,
  PublishDate,
  imagePosition = 'left',
}: NewsBlockProps) => {
  const formatPublishDate = (date: string) => {
    // TODO: ask to do this in backend
    const options: Intl.DateTimeFormatOptions = {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    };
    const formattedDate = new Date(date).toLocaleDateString(undefined, options);
    return formattedDate;
  };

  return (
    <React.Fragment key={Key}>
      <div className='news-block-container'>
        <div
          className={classNames('news-block', {
            'right-image': imagePosition === 'right',
            'top-image': imagePosition === 'top',
          })}
        >
          <div className='news-block-image'>
            <a href={ImageUrl} target='_blank'>
              <img src={Image} loading='lazy' alt={Image} height='360' width='640' />
            </a>
          </div>
          <div className='news-block-content'>
            <a href={TopicUrl}>
              <p className='news-block-topic font-bold-xs-lh-150'>{Topic}</p>
            </a>
            <a href={ImageUrl} target='_blank'>
              <h3 className='news-block-title'>{Title}</h3>
            </a>
            {Description && (
              <p className='news-block-description font-light-md-lh-150'>{Description}</p>
            )}
            <p className='news-block-date font-light-sm-lh-140'>{formatPublishDate(PublishDate)}</p>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};
